import React from "react";
import { addProducts } from "../../services/ProductService";
import "react-datepicker/dist/react-datepicker.css";
import {Button} from "react-bootstrap";
import * as XLSX from 'xlsx';

function UploadButton() {
  const inputReference = React.createRef();

  const fileUploadAction = () => inputReference.current.click();
  const floatParser = (n) => (!isNaN(parseFloat(n)) && isFinite(n))? parseFloat(n) : null;
  const intParser = (n) => (!isNaN(parseInt(n)) && isFinite(n)) ? parseInt(n) : null;

  const templateKeys = [
    /* | name | required | parser |*/
    ["Name", true],
    ["BarCode", true],
    ["Picture", true],
    ["Price", true, floatParser],
    ["CashbackPercentage",true, floatParser],
    ["Active", true, Boolean],
    ["MaxQuantity", true, intParser],
    ["SellingPrice", true, floatParser],
    ["ProductOrder", true, intParser],
    ["BrandId", true],
    ["MaxQuantitySpanLimit",true, intParser],
    ["FmcgId", true],
    ["X3Code", false ],
    ["IsBatch",true, Boolean],
    ["InitialStock", true, intParser]
  ]

  const validateXlxsData = (data) => {
    if (data.length <= 1) {
      alert('excel file is empty or invalid');
      return null;
    }
    const keys = data[0];
    for (let i = 0; i < templateKeys.length; i++) {
      if (keys[i] !== templateKeys[i][0]) {
        alert(`expected column ${templateKeys[i][0]} but found ${keys[i]}`);
        return null;
      }
    }

    let products = [];
    for (let dataIndex = 1; dataIndex < data.length; dataIndex++) {
      let productData = data[dataIndex];
      let product = {};
      if (productData.length == 0)
        continue ;
      for (let i = 0; i < templateKeys.length; i++) {

        const key = templateKeys[i][0];
        const parser = templateKeys[i][2]
        let value = productData[i];
        const required = templateKeys[i][1]
        if (required && (value === undefined || value.length === 0)) {
          alert(`undefined value for key ${key}`)
          return null;
        }
        if (parser) {
          if ((value = parser(value)) === null) {
            alert(`invalid value :'${productData[i]}' for key ${key}`)
            return null;
          }
        }
        if (value)
          product[key] = value;
      }
      products.push(product);
    }
    if (products.length === 0) {
      alert('excel file is empty or invalid');
      return null;
    }
    console.log(JSON.stringify(products));
    return products;
  }


  const handleUploadExcelFile = (e) => {
    var file = e.target.files[0];
    const reader = new FileReader();
    
    reader.onload = async (event) => {
        const binaryString = event.target.result;
        const xlsx = XLSX.read(binaryString, {type:'binary'});
        const sheetName = xlsx.SheetNames[0];
        const sheet = xlsx.Sheets[sheetName];
        const data = XLSX.utils.sheet_to_json(sheet, {header:1});
        let products = validateXlxsData(data);
        if (products) {
          const response = await addProducts(products);
          if (response) {
            if (response.success) {
              alert("products added successfully")
            }
            else {
              alert("Error : " + response.error)
            }
          }
        }
    };
    reader.readAsBinaryString(file);
  }

  return (
    <>
        <input type="file" hidden ref={inputReference} onChange={handleUploadExcelFile} />
        <Button onClick={fileUploadAction} variant="success" >Upload Excel</Button>
    </>
  );
}

export default UploadButton;
